import React from 'react';
import { PageHero } from '../components/PageHero';
export function ProfessionalRegistration() {
  return <div className="animate-fade-in-up" data-id="element-637">
      <PageHero title="Professional Registration" subtitle="Regulated by CRPO" data-id="element-638" />
      <section className="py-16 md:py-24 bg-white" data-id="element-639">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 text-teal/80 leading-relaxed" data-id="element-640">
          <div className="space-y-4" data-id="element-641">
            <p className="text-lg" data-id="element-642">
              Arrive Psychotherapy & Wellness is owned and operated by Jessica
              Ruppert, MA, a Registered Psychotherapist (Qualifying) regulated
              by the College of Registered Psychotherapists of Ontario (CRPO).
            </p>
          </div>

          <div className="bg-neutral-soft p-8 rounded-xl border border-sage/20" data-id="element-643">
            <h2 className="text-2xl font-medium text-teal mb-4" data-id="element-644">
              My Credentials
            </h2>
            <div className="space-y-2" data-id="element-645">
              <p className="font-semibold text-lg" data-id="element-646">Jessica Ruppert</p>
              <p data-id="element-647">Master of Arts (MA) in Counselling Psychology</p>
              <p data-id="element-648">Registered Psychotherapist (Qualifying)</p>
              <div className="mt-4 pt-4 border-t border-sage/20 text-sm space-y-1" data-id="element-649">
                <p data-id="element-650">CRPO Registration Number: 15311</p>
                <p data-id="element-651">
                  <strong data-id="element-652">Registration Category:</strong> Registered
                  Psychotherapist (Qualifying)
                </p>
                <p data-id="element-653">
                  <strong data-id="element-654">Initial Registration Date:</strong> September 24, 2023
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4" data-id="element-655">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-656">
              What Does "RP (Qualifying)" Mean?
            </h2>
            <p data-id="element-657">As a Registered Psychotherapist (Qualifying), I am:</p>
            <ul className="space-y-2" data-id="element-658">
              <li className="flex items-start" data-id="element-659">
                <span className="mr-2 text-terracotta" data-id="element-660">✅</span> Fully
                authorized to practice psychotherapy in Ontario
              </li>
              <li className="flex items-start" data-id="element-661">
                <span className="mr-2 text-terracotta" data-id="element-662">✅</span> Regulated by
                the College of Registered Psychotherapists of Ontario
              </li>
              <li className="flex items-start" data-id="element-663">
                <span className="mr-2 text-terracotta" data-id="element-664">✅</span> Required to
                practice under clinical supervision (as mandated by CRPO)
              </li>
              <li className="flex items-start" data-id="element-665">
                <span className="mr-2 text-terracotta" data-id="element-666">✅</span> Meeting
                registration requirements to transition to full Registered
                Psychotherapist (RP) status
              </li>
              <li className="flex items-start" data-id="element-667">
                <span className="mr-2 text-terracotta" data-id="element-668">✅</span> Held to the
                same professional and ethical standards as all RPs in Ontario
              </li>
            </ul>
            <p className="text-sm italic mt-2" data-id="element-669">
              The "Qualifying" designation means I am working toward completing
              the supervised practice hours required for independent practice.
            </p>
          </div>

          <div className="space-y-4" data-id="element-670">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-671">
              Clinical Supervision
            </h2>
            <p data-id="element-672">
              As required by CRPO, I practice under the clinical supervision of:
            </p>
            <div className="bg-neutral-soft p-4 rounded-lg inline-block" data-id="element-673">
              <p data-id="element-674">
                <strong data-id="element-675">Lori Eaton</strong>
              </p>
              <p data-id="element-676"></p>
            </div>
            <p data-id="element-677">
              You are welcome to contact my clinical supervisor with any
              questions or concerns about the services I provide:
            </p>
            <p data-id="element-678">Email: [To be added]</p>
          </div>

          <div className="space-y-4" data-id="element-679">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-680">
              About CRPO
            </h2>
            <p data-id="element-681">
              The College of Registered Psychotherapists of Ontario (CRPO) is
              the regulatory body for psychotherapists in Ontario, established
              under the Psychotherapy Act, 2007.
            </p>
            <h3 className="text-xl font-medium text-sage" data-id="element-682">CRPO's Role:</h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-683">
              <li data-id="element-684">Sets standards for the profession</li>
              <li data-id="element-685">Ensures psychotherapists are qualified and competent</li>
              <li data-id="element-686">Protects the public by investigating complaints</li>
              <li data-id="element-687">Maintains a public register of all members</li>
              <li data-id="element-688">Enforces professional and ethical standards</li>
            </ul>
            <p className="font-medium text-teal" data-id="element-689">
              Only individuals registered with CRPO are legally authorized to
              use the title "Registered Psychotherapist" or "Psychotherapist"
              and perform the controlled act of psychotherapy in Ontario.
            </p>
          </div>

          <div className="space-y-4" data-id="element-690">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-691">
              Verify My Registration
            </h2>
            <p data-id="element-692">
              You can verify my registration status on the CRPO Public Register:
            </p>
            <a href="https://www.crpo.ca/find-a-registered-psychotherapist/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-teal text-white rounded-lg hover:bg-teal-hover transition-colors" data-id="element-693">
              🔗 Verify Registration on CRPO Public Register
            </a>
            <div className="mt-4" data-id="element-694">
              <p className="font-medium mb-2" data-id="element-695">To search:</p>
              <ol className="list-decimal pl-5 space-y-1" data-id="element-696">
                <li data-id="element-697">Visit the link above</li>
                <li data-id="element-698">
                  Enter my name: <strong data-id="element-699">Jessica Ruppert</strong>
                </li>
                <li data-id="element-700">
                  Or search by registration number: <strong data-id="element-701">15311</strong>
                </li>
              </ol>
            </div>
            <p className="text-sm" data-id="element-702">
              The Public Register shows my current registration status,
              registration category, any terms or conditions on my practice, and
              any disciplinary history.
            </p>
          </div>

          <div className="space-y-4" data-id="element-703">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-704">
              Professional Standards & Code of Ethics
            </h2>
            <p data-id="element-705">As a CRPO registrant, I am bound by:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-706">
              <li data-id="element-707">
                <strong data-id="element-708">CRPO Code of Ethics</strong> - Ethical principles that
                guide my professional conduct
              </li>
              <li data-id="element-709">
                <strong data-id="element-710">Professional Practice Standards</strong> - Standards for
                clinical practice, record-keeping, confidentiality, informed
                consent
              </li>
              <li data-id="element-711">
                <strong data-id="element-712">Psychotherapy Act, 2007</strong> - Ontario legislation
                governing the practice of psychotherapy
              </li>
              <li data-id="element-713">
                <strong data-id="element-714">Regulated Health Professions Act, 1991</strong> -
                Ontario legislation for all regulated health professionals
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-715">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-716">
              Your Rights as a Client
            </h2>
            <p data-id="element-717">
              As a client of a CRPO-regulated psychotherapist, you have the
              right to:
            </p>
            <ul className="space-y-2" data-id="element-718">
              <li className="flex items-start" data-id="element-719">
                <span className="mr-2 text-terracotta" data-id="element-720">✅</span> Receive
                competent, ethical, and professional services
              </li>
              <li className="flex items-start" data-id="element-721">
                <span className="mr-2 text-terracotta" data-id="element-722">✅</span> Be treated with
                respect and dignity
              </li>
              <li className="flex items-start" data-id="element-723">
                <span className="mr-2 text-terracotta" data-id="element-724">✅</span> Have your
                privacy and confidentiality protected
              </li>
              <li className="flex items-start" data-id="element-725">
                <span className="mr-2 text-terracotta" data-id="element-726">✅</span> Provide
                informed consent before beginning treatment
              </li>
              <li className="flex items-start" data-id="element-727">
                <span className="mr-2 text-terracotta" data-id="element-728">✅</span> Access your
                clinical records
              </li>
              <li className="flex items-start" data-id="element-729">
                <span className="mr-2 text-terracotta" data-id="element-730">✅</span> Be informed
                about my qualifications and supervision arrangements
              </li>
              <li className="flex items-start" data-id="element-731">
                <span className="mr-2 text-terracotta" data-id="element-732">✅</span> File a
                complaint if you have concerns about my conduct or practice
              </li>
            </ul>
          </div>

          <div className="space-y-4 border-t border-sage/20 pt-8" data-id="element-733">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-734">
              How to File a Complaint
            </h2>

            <h3 className="text-xl font-medium text-sage" data-id="element-735">
              Step 1: Speak With Me First
            </h3>
            <p data-id="element-736">
              I encourage you to raise concerns directly with me. Most issues
              can be resolved through open communication.
            </p>

            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-737">
              Step 2: File a Complaint with CRPO
            </h3>
            <div className="pl-4 border-l-2 border-sage/30" data-id="element-738">
              <p data-id="element-739">
                <strong data-id="element-740">
                  College of Registered Psychotherapists of Ontario
                </strong>
              </p>
              <p data-id="element-741">375 University Avenue, Suite 800, Toronto, ON M5G 2J5</p>
              <p data-id="element-742">Phone: 416-479-4330 or 1-844-712-1364</p>
              <p data-id="element-743">Email: info@crpo.ca</p>
              <p data-id="element-744">
                Website:{' '}
                <a href="https://www.crpo.ca" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-745">
                  www.crpo.ca
                </a>
              </p>
              <p data-id="element-746">
                Complaint Process:{' '}
                <a href="https://www.crpo.ca/complaints/" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-747">
                  https://www.crpo.ca/complaints/
                </a>
              </p>
            </div>

            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-748">
              For Privacy Complaints:
            </h3>
            <div className="pl-4 border-l-2 border-sage/30" data-id="element-749">
              <p data-id="element-750">
                <strong data-id="element-751">Information and Privacy Commissioner of Ontario</strong>
              </p>
              <p data-id="element-752">2 Bloor Street East, Suite 1400, Toronto, ON M4W 1A8</p>
              <p data-id="element-753">Phone: 416-326-3333 or 1-800-387-0073</p>
              <p data-id="element-754">
                Website:{' '}
                <a href="https://www.ipc.on.ca" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-755">
                  www.ipc.on.ca
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}